import AutoSync from "assets/icons/AutoSyncIcon";
import SavedLocally from "assets/icons/SavedLocallyIcon";
import SingleChevron from "assets/icons/SingleChevron";
import React, { useState } from "react";
import styles from "../TemplateSyncListItem/TemplateSyncListItem.module.scss";
import { FormTemplate } from "db/definitions";
import { Colors } from "@factorearth/component-library/dist/Theme/types";

interface Props {
	additionalTemplates?: FormTemplate[];
	checked?: boolean;
	color: Colors;
	formTemplate: FormTemplate;
	handleSelect: (formTemplate: FormTemplate) => void;
	isAutoSyncing: boolean;
	isOffline: boolean;
	offlineTemplatesMap: Record<string, FormTemplate>;
	selectedSet: Set<string>;
	disableAccordion?: boolean;
}

function TemplateListSyncItem(props: Props) {
	const { additionalTemplates, checked, color, formTemplate, handleSelect, isAutoSyncing, isOffline, offlineTemplatesMap, selectedSet, disableAccordion } =
		props;

	const [isDetailsOpen, setIsDetailsOpen] = useState(false);

	const toggleDetails = () => {
		setIsDetailsOpen(!isDetailsOpen);
	};

	const [isVersionOpen, setIsVersionOpen] = useState(false);

	function toggleVersion() {
		setIsVersionOpen(!isVersionOpen);
	}

	function convertDateTime(inputDateTimeString: string): string {
		const inputDate = new Date(inputDateTimeString);
		const finalDate = inputDate.toLocaleString("en-US", { timeZoneName: "short" });
		return finalDate;
	}

	function handleCheckBoxClick() {
		handleSelect(formTemplate);
	}

	return (
		<>
			<div
				className={styles.wrapper}
				key={formTemplate.id}
				style={{
					background: color.background.primary,
					color: color.text.primary,
					borderBottom: `0.5px solid ${color.background.secondary}`,
				}}>
				<input type="checkbox" className={styles.checkbox} onChange={handleCheckBoxClick} checked={checked ? true : false} />
				<div className={styles.infoAndToggle}>
					<div className={styles.info}>
						<div className={styles.name} onClick={toggleDetails} role="button">
							{formTemplate.template}
							{formTemplate.versionName ? `- ${formTemplate.versionName}` : null}
						</div>
						{isOffline && <SavedLocally color={color.text.primary} />}
						{isAutoSyncing && <AutoSync color={color.text.primary} />}
					</div>
					{!disableAccordion && (
						<div onClick={toggleDetails} className={styles.toggle}>
							<SingleChevron direction={isDetailsOpen ? "up" : "down"} color={color.text.primary} />
						</div>
					)}
				</div>
			</div>
			{isDetailsOpen && !disableAccordion && (
				<>
					<div
						className={styles.detailsWrapper}
						style={{
							background: color.background.tertiary,
							color: color.text.primary,
						}}>
						<div className={styles.details_top}>
							<div className={styles.groupsWidth}>
								<p className={styles.text} style={{ fontWeight: "bold" }}>
									{formTemplate.templateName ? formTemplate.templateName : formTemplate.template}
								</p>
								<div className={styles.groups}>
									<p className={styles.text}>{formTemplate.description}</p>
									{/* <p>{formTemplateGroup}</p> */}
								</div>
							</div>
							<div style={{ width: "50%" }}>
								<div onClick={toggleVersion} className={styles.toggle}>
									<p className={styles.text} style={{ fontWeight: "bold" }}>
										Version
									</p>
									{/* <SingleChevron direction={isVersionOpen ? "up" : "down"} color={color.utils.success} /> */}
								</div>
								<p className={styles.version}>
									{formTemplate.versionName && formTemplate.versionName !== "" ? formTemplate.versionName : "default"}
								</p>
							</div>
						</div>
						<div className={styles.details_bottom}>
							<div className={styles.created}>
								<div className={styles.update_create_wrapper}>
									<p className={styles.text} style={{ fontWeight: "bold", marginRight: "0.75em" }}>
										Created by:
									</p>
									<p className={styles.text}>{formTemplate.createdBy}</p>
								</div>
								<div className={styles.update_create_wrapper}>
									<p className={styles.text} style={{ fontWeight: "bold", marginRight: "0.75em" }}>
										Created at:
									</p>
									<p className={styles.text}>{convertDateTime(formTemplate.createdAt)}</p>
								</div>
							</div>
							<div className={styles.updated}>
								<div className={styles.update_create_wrapper}>
									<p className={styles.text} style={{ fontWeight: "bold", marginRight: "0.75em" }}>
										Updated by:
									</p>
									<p className={styles.text}>{formTemplate.updatedBy}</p>
								</div>
								<div className={styles.update_create_wrapper}>
									<p className={styles.text} style={{ fontWeight: "bold", marginRight: "0.75em" }}>
										Updated at:
									</p>
									<p className={styles.text}>{convertDateTime(formTemplate.updatedAt)}</p>
								</div>
							</div>
						</div>
						{additionalTemplates && (
							<>
								<div className={styles.variations}>Template Variations (Included in Save)</div>
								{additionalTemplates.map((additionalTemplate) => {
									if (additionalTemplate.id == formTemplate.id) {
										return null;
									} else {
										return (
											<TemplateListSyncItem
												key={`template-sync-menu-list-item-${additionalTemplate.id}`}
												formTemplate={additionalTemplate}
												isOffline={offlineTemplatesMap[additionalTemplate.id] ? true : false}
												isAutoSyncing={isAutoSyncing}
												color={color}
												handleSelect={handleSelect}
												checked={selectedSet.has(additionalTemplate.id) ? true : false}
												offlineTemplatesMap={{}}
												selectedSet={new Set([])}
											/>
										);
									}
								})}
							</>
						)}
					</div>
				</>
			)}
		</>
	);
}

export default TemplateListSyncItem;
